/** The shared terminology server, used unless the build points at another. */
export const terminologyUrl = () => import.meta.env.VITE_TERMINOLOGY_URL || 'https://terminology.fhir.cloud.bestnotesfhir.com';

/**
 * Marks a `$httpFhirApi` request config as a terminology read and sends it to the terminology
 * server. Under VITE_TERMINOLOGY_LOCAL no baseURL is set, so the request interceptor routes it to
 * the account's own Aidbox instead.
 *
 * @param {object} [config] - Request config to extend; it is updated in place and returned.
 * @returns {object}
 */
export const withTerminology = (config = {}) => {
    config.terminology = true;
    if (!import.meta.env.VITE_TERMINOLOGY_LOCAL) {
        config.baseURL = terminologyUrl();
    }
    return config;
};
